export const formInvokeSuggestions = [{
  title: '使用传给弹窗或页面的id进行查询',
  getInvoke: () => ({
    method: 'get',
    args: ['props.id'],
    enabled: true
  })
}, {
  title: '使用url上的id参数进行查询',
  getInvoke: () => ({
    method: 'get',
    args: ['$query.id'],
    enabled: true
  })
}];
export const invokeSuggestions = {
  form_JS: formInvokeSuggestions
};
//# sourceMappingURL=invokeSuggestions.js.map
